import templateUrl from './angularjsLogin.html';
import controller from './loginController.js';

export default {
  controller,
  controllerAs: 'loginController',
  templateUrl
};
